"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGrid = exports.GKDataGridContext = exports.caseInsensitiveGridSort = void 0;
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
var React = __importStar(require("react"));
var react_table_1 = require("react-table");
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var _1 = require("./");
var GKDataGridWrapper_1 = require("./GKDataGridWrapper");
var GKDataGridBody_1 = require("./GKDataGridBody");
var __1 = require("../../");
var hooks_1 = require("../../common/hooks");
require("./GKDataGrid.css");
// A case-insensitive string sorting function.
// This is the default sorting function for columns.
var caseInsensitiveGridSort = function (rowA, rowB, id) {
    var valA = rowA.values[id];
    var valB = rowB.values[id];
    if (typeof valA === "string" || typeof valB === "string") {
        var lValA = String(valA || "").toLowerCase();
        var lValB = String(valB || "").toLowerCase();
        return lValA > lValB ? 1 : lValB > lValA ? -1 : 0;
    }
    return valA > valB ? 1 : valB > valA ? -1 : 0;
};
exports.caseInsensitiveGridSort = caseInsensitiveGridSort;
/**
 * Provides getter and setter for individual row heights, as well as
 * the height of the table header and footer. Used when virtualizing to
 * ensure we reserve the proper amount of space for all elements
 */
exports.GKDataGridContext = React.createContext({
    setRowHeight: function () { return null; },
    getRowHeight: function () { return 0; },
});
var GKDataGrid = function (props) {
    // --- PROPS: Destructuring and assigning defaults. ---
    var _a, _b, _c;
    var _d = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-data-grid-v2",
        className: [
            "d-flex flex-column",
            props.disableResizing && "no-resizing",
            props.disableAutosizing && "no-autosizing",
            props.virtualize && "virtualized",
        ]
            .filter(function (c) { return c; })
            .join(" "),
    }), autoResetSortBy = _d.autoResetSortBy, propColumns = _d.columns, propData = _d.data, qaProp = _d["data-qa"], defaultExpanded = _d.defaultExpanded, defaultSelected = _d.defaultSelected, defaultSorted = _d.defaultSorted, _e = _d.defaultVirtualRowHeight, defaultVirtualRowHeight = _e === void 0 ? 62 : _e, 
    // Intentionally destructured out of ...otherProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    disableAutosizing = _d.disableAutosizing, disableResizing = _d.disableResizing, disableSortBy = _d.disableSortBy, disableRowSelection = _d.disableRowSelection, expanderTdPrependElement = _d.expanderTdPrependElement, expanderTdPrependText = _d.expanderTdPrependText, expanderThPrependText = _d.expanderThPrependText, expanderHeader = _d.expanderHeader, expanderTitle = _d.expanderTitle, expanderWidth = _d.expanderWidth, footer = _d.footer, getRowId = _d.getRowId, headerColor = _d.headerColor, id = _d.id, instanceRef = _d.instanceRef, isLoadingProp = _d.isLoading, rowProps = _d.rowProps, gridLines = _d.gridLines, onExpandChange = _d.onExpandChange, onSelection = _d.onSelection, onSortChange = _d.onSortChange, renderFunction = _d.renderFunction, rowDetail = _d.rowDetail, rowHover = _d.rowHover, rowOnClick = _d.rowOnClick, stateReducer = _d.stateReducer, virtualize = _d.virtualize, otherProps = __rest(_d, ["autoResetSortBy", "columns", "data", "data-qa", "defaultExpanded", "defaultSelected", "defaultSorted", "defaultVirtualRowHeight", "disableAutosizing", "disableResizing", "disableSortBy", "disableRowSelection", "expanderTdPrependElement", "expanderTdPrependText", "expanderThPrependText", "expanderHeader", "expanderTitle", "expanderWidth", "footer", "getRowId", "headerColor", "id", "instanceRef", "isLoading", "rowProps", "gridLines", "onExpandChange", "onSelection", "onSortChange", "renderFunction", "rowDetail", "rowHover", "rowOnClick", "stateReducer", "virtualize"]);
    var uniqueId = (0, hooks_1.usePersistentId2)(id);
    // Handle merging expander props
    var expTdText = expanderTdPrependText !== null && expanderTdPrependText !== void 0 ? expanderTdPrependText : expanderTitle;
    var expThText = expanderThPrependText !== null && expanderThPrependText !== void 0 ? expanderThPrependText : expanderHeader;
    // -- CUSTOM RENDERING: Objects and functions for building out our custom rendered bits. ---
    // NOTE: Some of these could move out of the main function easily; others need to be converted to functions.
    // Helper function
    var handleOnKeyDown = function (e, key, callback) {
        if (e.key === key || (key instanceof Array && key.includes(e.key))) {
            e.preventDefault();
            callback();
        }
    };
    // The expander column.
    var expanderColumn = {
        Cell: function (_a) {
            var row = _a.row;
            var qa = qaProp + "--expander-" + row.id;
            var id = uniqueId + "--expander-" + row.id;
            var DataGridCell = (React.createElement(React.Fragment, null, expanderTdPrependElement === null || expanderTdPrependElement === void 0 ? void 0 :
                expanderTdPrependElement(row),
                React.createElement(__1.GKButton, __assign({}, row.getToggleRowExpandedProps(), { color: "link", className: "expander ml-auto p-0" + (row.isExpanded ? " expanded" : ""), onKeyDown: function (e) {
                        return handleOnKeyDown(e, ["Enter", " "], row.toggleRowExpanded);
                    }, "data-qa": qa, id: id, "aria-expanded": row.isExpanded, "aria-controls": "row-" + row.id + "-subcomponent", icon: __1.GKIconName.KeyboardArrowDown, iconPosition: "after" }), expTdText && React.createElement("span", null, expTdText(row)))));
            return DataGridCell;
        },
        Header: function (_a) {
            var getToggleAllRowsExpandedProps = _a.getToggleAllRowsExpandedProps, isAllRowsExpanded = _a.isAllRowsExpanded;
            var qa = qaProp + "--expander-all";
            var id = uniqueId + "--expander-all";
            var DataGridHeader = (React.createElement(__1.GKButton, __assign({}, getToggleAllRowsExpandedProps(), { color: "link", className: "expander ml-auto p-0" + (isAllRowsExpanded ? " expanded" : ""), onKeyDown: function (e) {
                    return handleOnKeyDown(e, ["Enter", " "], 
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    tableInstance.toggleAllRowsExpanded);
                }, icon: __1.GKIconName.KeyboardArrowDown, iconPosition: "after", "data-qa": qa, id: id }), expThText && React.createElement("span", null, expThText(isAllRowsExpanded))));
            return DataGridHeader;
        },
        disableResizing: true,
        disableSortBy: true,
        id: "gk-expansion",
        width: expanderWidth !== null && expanderWidth !== void 0 ? expanderWidth : 40,
    };
    // The selection column.
    var selectionColumn = {
        Cell: function (_a) {
            var row = _a.row;
            var qa = qaProp + "--checkbox-" + row.id;
            var id = uniqueId + "--checkbox-" + row.id;
            var SelectionColumnCell = (React.createElement(__1.GKCheckbox, __assign({ id: id, "data-qa": qa, className: "m-0", disabled: disableRowSelection }, row.getToggleRowSelectedProps())));
            return SelectionColumnCell;
        },
        Header: function (_a) {
            var getToggleAllRowsSelectedProps = _a.getToggleAllRowsSelectedProps;
            var qa = qaProp + "--checkbox-all";
            var id = uniqueId + "--checkbox-all";
            var SelectionColumnHeader = (React.createElement(__1.GKCheckbox, __assign({ id: id, "data-qa": qa, className: "m-0", disabled: disableRowSelection }, getToggleAllRowsSelectedProps())));
            return SelectionColumnHeader;
        },
        disableResizing: true,
        disableSortBy: true,
        id: "gk-selection",
        width: 40,
        maxWidth: 40,
    };
    // Generate the sort icon.
    var getSortIcon = function (sorted, desc, colId) {
        if (sorted === void 0) { sorted = false; }
        if (desc === void 0) { desc = true; }
        return (React.createElement("div", { className: "d-flex flex-column sorter", tabIndex: 0, onKeyDown: function (e) {
                return handleOnKeyDown(e, "Enter", function () {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    return tableInstance.toggleSortBy(colId, !desc, false);
                });
            } },
            React.createElement(__1.GKIcon, { className: ["sort-asc", sorted && !desc ? "active" : ""]
                    .filter(function (c) { return c; })
                    .join(" "), name: __1.GKIconName.ArrowDropUp }),
            React.createElement(__1.GKIcon, { className: ["sort-desc", sorted && desc ? "active" : ""]
                    .filter(function (c) { return c; })
                    .join(" "), name: __1.GKIconName.ArrowDropDown })));
    };
    // Custom hooks. Currently unused.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var runCustomHooks = function (hooks) {
        // NOTE: This is a placeholder for now, in case I need it later.
    };
    // Generate the data grid headers.
    var getHeaders = function () {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return headerGroups.map(function (group) { return (
        // eslint-disable-next-line react/jsx-key
        React.createElement("div", __assign({ "data-qa": qaProp + "--tr", className: "tr" }, group.getHeaderGroupProps()), group.headers.map(function (col, i) { return (
        // eslint-disable-next-line react/jsx-key
        React.createElement("div", __assign({ "data-qa": qaProp + "--th", className: ["th", "col-" + col.id, col.isResizing && "resizing"]
                .filter(function (c) { return c; })
                .join(" ") }, col.getHeaderProps()),
            React.createElement("div", __assign({}, col.getSortByToggleProps(), { className: "d-flex align-items-center" }),
                col.render("Header"),
                !col.disableSortBy &&
                    !disableSortBy &&
                    getSortIcon(col.isSorted, col.isSortedDesc, col.id)),
            col.canFilter && col.Filter && col.render("Filter"),
            col.canResize && i < group.headers.length - 1 && (React.createElement("div", __assign({ className: "resizer" }, col.getResizerProps()))))); }))); });
    };
    // Returns a single grid row
    var getRow = function (virtualIndex, style) {
        var row = rows[virtualIndex];
        return (React.createElement(_1.GKDataGridRow, { key: row.id, virtualIndex: virtualize ? virtualIndex : undefined, style: style, 
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            isTableResizing: tableInstance.allColumns.some(function (col) { return col.isResizing; }), isSelected: row.isSelected, isExpanded: row.isExpanded, onClick: rowOnClick, original: __assign({}, row.original), row: row, qaProp: qaProp, rowDetail: function () {
                return rowDetail === null || rowDetail === void 0 ? void 0 : rowDetail(row);
            }, 
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            prepareRow: prepareRow, rowProps: rowProps
                ? function (row) {
                    return rowProps === null || rowProps === void 0 ? void 0 : rowProps(row, limitedInstance);
                }
                : undefined, limitedInstance: limitedInstance }));
    };
    // Returns a single "loading" row.
    var getLoadingRow = function (key, style) { return (React.createElement("div", { className: "tr-group", key: "loading-" + key, style: style },
        React.createElement("div", { "data-qa": qaProp + "--tr", className: "tr d-flex w-100" }, visibleColumns.map(function (col, a) { return (React.createElement("div", __assign({ "data-qa": qaProp + "--td", className: "td col-" + col.id }, col.getHeaderProps(), { key: a }),
            React.createElement(__1.GKLoadingPlaceholder, { className: "w-75" }))); })))); };
    // --- HOOKS ---
    // Set some refs.
    var theadRef = React.useRef(null);
    var tbodyRef = React.useRef(null);
    var tfootRef = React.useRef(null);
    var rowHeights = React.useRef([]);
    var listRef = React.useRef(null);
    // Set state.
    var _f = React.useState(isLoadingProp !== null && isLoadingProp !== void 0 ? isLoadingProp : false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = React.useState([]), data = _g[0], setData = _g[1];
    var _h = React.useState(0), scrollbarPadding = _h[0], setScrollbarPadding = _h[1];
    var imLoading = isLoadingProp !== null && isLoadingProp !== void 0 ? isLoadingProp : isLoading;
    // Handle column preparation.
    var responsiveColumns = (0, hooks_1.useResponsive2)(propColumns) || [];
    var columns = React.useMemo(function () {
        var cols = __spreadArray([], responsiveColumns, true);
        if (onSelection) {
            cols.unshift(selectionColumn);
        }
        if (rowDetail) {
            cols.push(expanderColumn);
        }
        return cols;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expanderHeader,
        expanderTitle,
        expanderWidth,
        responsiveColumns,
        onSelection,
        rowDetail,
        disableRowSelection,
    ]);
    // Handle Promise data.
    // Calling this when the loading prop changes ensures the table rerenders rows.
    React.useEffect(function () {
        setIsLoading(propData instanceof Promise);
        Promise.resolve(propData).then(function (promisedData) {
            setIsLoading(false);
            setData(promisedData);
        });
    }, [propData, isLoadingProp]);
    // Memoize before passing
    var defaultSortType = React.useMemo(function () { return exports.caseInsensitiveGridSort; }, []);
    // Set up our react-table hooks and break out the data we need.
    var tableInstance = (0, react_table_1.useTable)({
        columns: columns,
        data: data,
        autoResetExpanded: false,
        defaultColumn: {
            sortType: defaultSortType,
        },
        disableResizing: disableResizing || false,
        disableSortBy: disableSortBy || false,
        disableSortRemove: true,
        initialState: {
            expanded: (defaultExpanded || {}),
            selectedRowIds: (defaultSelected || {}),
            sortBy: defaultSorted || [],
        },
        autoResetSortBy: autoResetSortBy,
        stateReducer: stateReducer,
        getRowId: getRowId,
    }, react_table_1.useFilters, react_table_1.useFlexLayout, react_table_1.useSortBy, react_table_1.useResizeColumns, react_table_1.useExpanded, react_table_1.useRowSelect, runCustomHooks);
    var getTableProps = tableInstance.getTableProps, getTableBodyProps = tableInstance.getTableBodyProps, headerGroups = tableInstance.headerGroups, rows = tableInstance.rows, selectedFlatRows = tableInstance.selectedFlatRows, visibleColumns = tableInstance.visibleColumns, prepareRow = tableInstance.prepareRow, _j = tableInstance.state, expanded = _j.expanded, sortBy = _j.sortBy;
    // Set up the instance ref
    var limitedInstance = {
        columns: tableInstance.columns,
        rows: tableInstance.rows,
        isAllRowsExpanded: tableInstance.isAllRowsExpanded,
        toggleAllRowsExpanded: tableInstance.toggleAllRowsExpanded,
        toggleRowExpanded: tableInstance.toggleRowExpanded,
        isAllRowsSelected: tableInstance.isAllRowsSelected,
        toggleAllRowsSelected: tableInstance.toggleAllRowsSelected,
        toggleRowSelected: tableInstance.toggleRowSelected,
        setAllFilters: tableInstance.setAllFilters,
        setFilter: tableInstance.setFilter,
        toggleSortBy: tableInstance.toggleSortBy,
        virtualList: listRef.current,
    };
    if (instanceRef) {
        instanceRef.current = limitedInstance;
    }
    // Handle row expanded change.
    var lastExpanded = React.useRef(defaultExpanded !== null && defaultExpanded !== void 0 ? defaultExpanded : {});
    React.useEffect(function () {
        if (!(0, react_fast_compare_1.default)(lastExpanded.current, expanded)) {
            onExpandChange === null || onExpandChange === void 0 ? void 0 : onExpandChange(expanded);
            lastExpanded.current = expanded;
        }
    }, [expanded, onExpandChange]);
    // Handle sorted columns change.
    var lastSort = React.useRef();
    React.useEffect(function () {
        var newSort = sortBy[sortBy.length - 1];
        if (!(0, react_fast_compare_1.default)(lastSort.current, newSort)) {
            onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(newSort);
            lastSort.current = newSort;
        }
    }, [onSortChange, sortBy]);
    // Handle selected rows change.
    // Strange hoop-jumping here, but it works (just checking selectedFlatRows.length does NOT)
    // NOTE: Might need a more accurate check for changes?
    var prevSelectedLength = React.useRef(0);
    React.useEffect(function () {
        if (selectedFlatRows.length !== prevSelectedLength.current) {
            onSelection === null || onSelection === void 0 ? void 0 : onSelection(selectedFlatRows.map(function (r) { return r.original; }));
            prevSelectedLength.current = selectedFlatRows.length;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFlatRows]);
    // Handle resizing to accomodate a scrollbar on the table body.
    // Fixes alignment issues between THs and TDs
    var handleScrollbarPadding = function () {
        var _a, _b;
        var fullWidth = ((_a = tbodyRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
        var scrollWidth = ((_b = tbodyRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth) || 0;
        var newPadding = Math.max(fullWidth - scrollWidth, 0);
        if (newPadding !== scrollbarPadding) {
            setScrollbarPadding(newPadding);
        }
    };
    // This keeps the column headers aligned with the columns when the table body
    // is scrolled horizontally in a virtualized data grid
    var matchMarginToScroll = function () {
        if (tbodyRef.current && theadRef.current) {
            theadRef.current.style.marginLeft = "-" + (tbodyRef.current.scrollLeft || 0) + "px";
        }
    };
    React.useEffect(function () {
        if (virtualize && tbodyRef.current) {
            var me_1 = tbodyRef.current;
            me_1.addEventListener("scroll", matchMarginToScroll);
            return function () { return me_1.removeEventListener("scroll", matchMarginToScroll); };
        }
        return;
    }, [tbodyRef, theadRef, virtualize]);
    // Functions for getting/setting row heights when rows are virtualized.
    var setRowHeight = function (index, height) {
        var _a;
        rowHeights.current[index] = height;
        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndex(0);
    };
    var getRowHeight = function (index) {
        var _a;
        return ((_a = rowHeights.current) === null || _a === void 0 ? void 0 : _a[index]) || defaultVirtualRowHeight;
    };
    React.useLayoutEffect(function () {
        handleScrollbarPadding();
        window.addEventListener("resize", handleScrollbarPadding);
        return function () {
            return window.removeEventListener("resize", handleScrollbarPadding);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, rows.length, (_a = tbodyRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth]);
    // -- RENDER ---
    if (renderFunction) {
        return renderFunction(limitedInstance);
    }
    return (React.createElement(exports.GKDataGridContext.Provider, { value: {
            setRowHeight: setRowHeight,
            getRowHeight: getRowHeight,
            getRow: getRow,
            headHeight: (_b = theadRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight,
            footHeight: (_c = tfootRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight,
        } },
        React.createElement(GKDataGridWrapper_1.GKDataGridWrapper, __assign({ virtualize: virtualize }, otherProps, { getTableProps: getTableProps, "data-qa": qaProp, id: uniqueId }),
            React.createElement("div", { role: "rowgroup", ref: theadRef, "data-qa": qaProp + "--thead", className: "thead bg-" + (headerColor !== null && headerColor !== void 0 ? headerColor : "light"), style: { paddingRight: scrollbarPadding } }, getHeaders()),
            React.createElement(GKDataGridBody_1.GKDataGridBody, __assign({}, getTableBodyProps(), { virtualize: virtualize, listRef: listRef, tbodyRef: tbodyRef, loading: imLoading, rowCount: imLoading ? 5 : rows.length, className: "tbody grid-lines-" + (gridLines !== null && gridLines !== void 0 ? gridLines : "horizontal") + (rowHover ? " row-hover" : ""), "data-qa": qaProp + "--tbody" }), imLoading
                ? __spreadArray([], Array(5), true).map(function (d, i) { return getLoadingRow(i); })
                : rows.map(function (row, i) { return getRow(i); })),
            footer && (React.createElement("div", { ref: tfootRef, "data-qa": qaProp + "--tfoot", className: "tfoot", role: "rowgroup" },
                React.createElement("div", { role: "row" },
                    React.createElement("div", { role: "cell" }, footer(limitedInstance))))))));
};
exports.GKDataGrid = GKDataGrid;
exports.default = exports.GKDataGrid;
